<template>
  <div class="container">
    <navbar></navbar>
    <div class="content-wrapper" :style="{height:height-50+'px'}">
      <sidebar width="220px"></sidebar>
      <app-main></app-main>
    </div>
  </div>
</template>
<script>
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import AppMain from './components/AppMain'

let bodyDom = document.body

export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  data () {
    return {
      height: bodyDom.clientHeight
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize (e) {
      this.height = bodyDom.clientHeight
    }
  }
}
</script>
<style lang="less" scoped>
.content-wrapper {
  width: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue